import api from '@/services/api/static.js'

const setStaticDataAction = (data) => {
    return {
        type: 'staticData/set',
        payload: {
            data: data,
            initialized: true,
        }
    }
}

const removeStaticDataAction = () => {
    sessionStorage.removeItem('orgsys')
    return {
        type: 'staticData/remove',
    }
}

const setStaticData = () => {
    return async (dispatch) => {
        // call pitstop API to get list of org/sys name
        const [error, data] = await api.index()
        if (error) {
            // TODO: handling error here...
            console.error('failed to request static data')
            return
        }
		try {
			sessionStorage.setItem('orgsys', JSON.stringify(data));
		} catch (e) {
			console.warn('failed to save static data to session storage')
		}
        dispatch(setStaticDataAction(data))
    }
}

export default {
    setStaticData,
    removeStaticDataAction,
}
